module.exports = __webpack_public_path__ + "media/images/prevention_form/cannabis-c482d22991cbb696c19a19db227faf85.svg";